import { FormControl, InputLabel, Select as MuiSelect } from '@material-ui/core';
import { ChangeEvent, ClassAttributes, createElement, FC, ReactChild, ReactNode, useState } from 'react';

type MenuItemElement = HTMLElement & {
  value: string;
};

type Props = ClassAttributes<MenuItemElement> & {
  label: ReactNode;
  defaultValue: string;
  overrideValue?: string;
  onChange: (e: ChangeEvent<{ value: unknown }>, value: string) => void;
  className?: string;
  children: ReactChild[];
};

const Select: FC<Props> = ({ label, className, children, defaultValue, onChange, overrideValue }) => {
  const [value, setValue] = useState(defaultValue);
  const name = `${Math.random()}`;

  return (
    <FormControl className={className}>
      <InputLabel htmlFor={`select-${name}`}>{label}</InputLabel>

      <MuiSelect
        value={overrideValue || value}
        onChange={(e) => {
          setValue(String(e.target.value));
          onChange(e, String(e.target.value));
        }}
        inputProps={{
          name,
          id: `select-${name}`,
        }}
      >
        {children}
      </MuiSelect>
    </FormControl>
  );
};

export default Select;
